<template>
  <div v-if="isAccountArea" v-frag>
    <li class="dropdown">
      <button
        type="button"
        class="nav-link btn-link-orange bg-orange btn-small text-white dropdown-toggle"
        role="button"
        data-toggle="dropdown"
        aria-expanded="false"
      >
        Account
      </button>

      <ul class="dropdown-menu dropdown-menu-right account-menu">
        <li class="nav-item">
          <a class="nav-link" :href="links.accountUrl">
            <img src="/Content/img/icons/icon-account.svg" alt="" />
            Your Account
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" :href="links.yourOrdersUrl">
            <img src="/Content/img/icons/icon-orders.svg" alt="" />
            Your Orders
          </a>
        </li>
        <li class="nav-item">
          <a
            v-if="links.emailPreferencesUrl"
            class="nav-link"
            :href="links.emailPreferencesUrl"
          >
            <img src="/Content/img/icons/icon-settings.svg" alt="" />
            Email Preferences
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" :href="links.logoutUrl" @click.prevent="onLogout">
            <img src="/Content/img/icons/icon-logout.svg" alt="" />
            Logout
          </a>
        </li>
      </ul>
    </li>
  </div>
  <div v-else>
    <a
      :href="links.dashboardUrl"
      class="nav-link btn-link-orange bg-orange text-white"
    >
      Dashboard
    </a>
  </div>
</template>

<script>
import frag from 'vue-frag';

import { clearGACookies } from '@/src/shared/authentication-utilities';

export default {
  name: 'ProfileHeader',

  directives: {
    frag,
  },

  props: {
    /** @type {import('vue').PropOptions<string>} */
    username: {
      default: '',
      type: String,
    },

    /** @type {import('vue').PropOptions<{ logoutUrl: string, accountUrl: string }>} */
    links: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      uiState: {
        isActive: false,
      },
    };
  },

  computed: {
    isAccountArea() {
      return location.pathname.toLowerCase().startsWith('/account');
    },
  },

  mounted() {
    document.addEventListener('click', this.onOutsideClick);
  },

  destroyed() {
    document.removeEventListener('click', this.onOutsideClick);
  },

  methods: {
    onOutsideClick(event) {
      if (!this.$el.contains(event.target) && this.uiState.isActive) {
        this.uiState.isActive = false;
      }
    },

    onLogout() {
      clearGACookies();

      window.location.href = this.links.logoutUrl;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/src/shared/styles/variables';
@import '~bootstrap/scss/_functions';
@import '~bootstrap/scss/_variables';
@import '~bootstrap/scss/_mixins';

.nav-item {
  color: $primary-color;
}
</style>
